import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { Settings, User } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useState } from "react";

export default function Header({ userInfo, setActiveSection }) {
  const [settingsOpen, setSettingsOpen] = useState(false);

  const getInitials = () => {
    if (userInfo?.name) {
      return userInfo.name.split(' ').map(n => n[0]).join('').toUpperCase();
    }
    return 'U';
  };

  return (
    <header className="h-16 bg-white dark:bg-neutral-900 border-b border-neutral-200 dark:border-neutral-800 flex items-center justify-between px-6" data-testid="portal-header">
      <div>
        <h2 className="text-lg font-semibold text-neutral-800 dark:text-white">Agent Portal</h2>
        <p className="text-sm text-neutral-500 dark:text-neutral-400">Manage your policies and performance</p>
      </div>
      
      <div className="flex items-center gap-4">
        {userInfo?.agent_id && (
          <div className="text-right">
            <p className="text-sm font-medium text-neutral-800 dark:text-white">{userInfo.name || 'Agent'}</p>
            <p className="text-xs text-neutral-500 dark:text-neutral-400">NPN: {userInfo.npn || userInfo.agent_id}</p>
          </div>
        )}
        
        <Avatar className="border-2" style={{ borderColor: '#d4af37' }}>
          <AvatarFallback className="bg-[#f4e5b8] text-[#b8941e] font-semibold">
            {getInitials()}
          </AvatarFallback>
        </Avatar>
        
        <Popover open={settingsOpen} onOpenChange={setSettingsOpen}>
          <PopoverTrigger asChild>
            <Button variant="ghost" size="icon" data-testid="settings-button">
              <Settings className="w-5 h-5 text-neutral-600" />
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-72 p-0" align="end">
            <div className="p-4 bg-gradient-to-r from-[#d4af37] to-[#b8941e]">
              <div className="flex items-center gap-3">
                <Avatar className="border-2 border-white">
                  <AvatarFallback className="bg-white text-[#b8941e] font-semibold">
                    {getInitials()}
                  </AvatarFallback>
                </Avatar>
                <div className="text-white">
                  <p className="text-sm font-semibold">{userInfo?.name || 'Agent'}</p>
                  <p className="text-xs opacity-90">{userInfo?.email || 'No email provided'}</p>
                </div>
              </div>
            </div>
            
            <div className="py-2">
              <button 
                className="w-full flex items-center gap-3 px-4 py-3 hover:bg-neutral-50 transition-colors text-left"
                onClick={() => {
                  setSettingsOpen(false);
                  if (setActiveSection) {
                    setActiveSection('profile-settings');
                  }
                }}
              >
                <User className="w-5 h-5 text-neutral-600" />
                <div>
                  <p className="text-sm font-medium text-neutral-800">Profile Settings</p>
                  <p className="text-xs text-neutral-500">Manage your account details</p>
                </div>
              </button>
            </div>
          </PopoverContent>
        </Popover>
      </div>
    </header>
  );
}